import { createContext, useContext } from 'react'

import { AppAbility } from '@/ability'

export const AbilityContext = createContext<AppAbility | null>(null)

export const useAbility = () => {
  const context = useContext(AbilityContext)
  if (!context) {
    throw new Error('useAbility must be used within a Ability.Provider')
  }
  return context
}
